/**
 * DropdownMenus for Header
 */

import Olark from '../../../../utils/olark';

import * as React from 'react';

import Button from '../../../atoms/buttons/Button';
import LinkButton from '../../../atoms/buttons/LinkButton';
import LogoutButton from '../../../atoms/buttons/LogoutButton';
import { DropdownMenuOptions } from '../../../molecules/blocks/DropdownMenu';
import { OrdersPagePath } from '../../../pages/account/Orders';
import { ProfilePagePath } from '../../../pages/account/Profile';
import { FAQPagePath } from '../../../pages/FAQ';
import { AboutUsPagePath, PricingPagePath } from '../BrandNavigation';

export const AccountDropDownMenuOptions: DropdownMenuOptions = [
  <LinkButton key="my-orders" label="My Orders" size="medium" to={OrdersPagePath} />,
  <LinkButton key="my-profile" label="My Profile" size="medium" to={ProfilePagePath} />,
  '-',
  <LogoutButton key="logout" size="medium" withIcon />,
];

export const HelpDropDownMenuOptions: DropdownMenuOptions = [
  <LinkButton key="faq" label="FAQ" size="medium" to={FAQPagePath} />,
  (
    <Button
      key="pricing"
      label="Pricing"
      size="medium"
      wrapperComponent="a"
      hyperLinkProps={{
        href: PricingPagePath,
        target: '_blank',
      }}
    />
  ),
  (
    <Button
      key="chat"
      label="Chat with our experts "
      size="medium"
      onClick={Olark.expand}
    />
  ),
  '-',
  (
    <Button
      key="about"
      label="About Us"
      size="medium"
      wrapperComponent="a"
      hyperLinkProps={{
        href: AboutUsPagePath,
        target: '_blank',
      }}
    />
  ),
  (
    <Button
      key="contact"
      label="Contact Page"
      size="medium"
      wrapperComponent="a"
      hyperLinkProps={{
        href: '/contact',
        target: '_blank',
      }}
    />
  ),
  '-',
  (
    <Button
      key="terms-conditions"
      label="Terms and Conditions"
      size="medium"
      wrapperComponent="a"
      hyperLinkProps={{
        href: '/terms-and-conditions',
        target: '_blank',
      }}
    />
  ),
  (
    <Button
      key="privacy"
      label="Privacy Policy"
      size="medium"
      wrapperComponent="a"
      hyperLinkProps={{
        href: '/privacy-policy',
        target: '_blank',
      }}
    />
  ),
];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/global/Header/DropdownMenus.tsx